import React, { Component } from 'react'

class Input extends Component {
	constructor(props, context) {
		super(props, context)
		this.state = {
			value: '',
		}
	}

	render() {
		return (
			<button
				onClick={this.props.onClick}
				className='btn'
				style={this.props.style}
				disabled={this.props.disabled}
			>
				{this.props.children}
			</button>
		)
	}
}

export default Input
